const state = {
    categorygroups:[],
};

const getters = {
    getSettingsCategorygroups: state => state.categorygroups,
};

const actions = {
    setSettingsCategorygroups: (store, payload) => store.commit("CATEGORYGROUPS_SET",payload),
};

const mutations = {
    CATEGORYGROUPS_SET: (state, payload) => state.categorygroups = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
